export function buildSupportingDocumentListParams({
  isCaseWorkspace,
  caseId,
  applicationId,
  filterApplicationId,
  filterInterventionId,
  isDeletedView,
}) {
  const params = new URLSearchParams();
  if (isCaseWorkspace) {
    if (filterInterventionId) params.set('interventionId', String(filterInterventionId));
    else if (caseId) params.set('caseId', String(caseId));
  } else if (filterApplicationId) {
    params.set('applicationId', String(filterApplicationId));
  } else {
    // caseId preserves the all-documents list. The exact application supplies
    // applicant identity context when the case has no linked portal account.
    if (caseId) params.set('caseId', String(caseId));
    if (applicationId) params.set('applicationId', String(applicationId));
  }
  if (isDeletedView) params.set('view', 'deleted');
  return params;
}
